import type { PageType, TrackingEvent, TrackingPayload } from '~/types/tracking'
import { useTopNavigationMenu } from '~/composables/useTopNavigationMenu'
import type { RouteLocationNormalized } from '#vue-router'
import { useError } from '#app'
import { getPageType } from '~/utils'
import { getPathPart } from '~/composables/getPageMetaFromPath'

const isErrorPage = () => {
  const error = useError()
  return error.value?.statusCode
}

const useContentEvents = (
  track: (event: TrackingEvent, payload: TrackingPayload) => void,
) => ({
  trackContentView: (
    contentName: string,
    title: string,
    pageType: PageType,
    pageTypeId: string,
    clickOrigin?: string,
  ) => {
    track('content_view', {
      content_name: contentName,
      title,
      page_type: pageType,
      page_type_id: pageTypeId,
      click_origin: clickOrigin,
    })
  },

  trackPageView: ({
    to,
    from,
  }: {
    from: RouteLocationNormalized
    to: RouteLocationNormalized
    pageMeta?: string
  }) => {
    const errorStatusCode = isErrorPage()

    const getNewPageMeta = errorStatusCode ?? getPathPart(to.fullPath)
    const getOldPageMeta = getPathPart(from.fullPath)

    const pageType = errorStatusCode ? 'errorpage' : getPageType(to)

    const { currentMenu, previousMenu } = useTopNavigationMenu()
    const lowerCaseShop = (shop: string | null) => shop?.toLowerCase()
    track('page_view', {
      new_location: {
        url: errorStatusCode
          ? `/${errorStatusCode}`
          : `${window.location.origin}${to.fullPath}`,
        page_type: pageType,
        page_meta: getNewPageMeta,
        content_type: to?.meta?.contentType,
        base_shop: lowerCaseShop(currentMenu.value),
      },
      old_location: {
        url: from?.fullPath
          ? `${window.location.origin}${from.fullPath}`
          : 'not set',
        page_type: getPageType(from),
        page_meta: getOldPageMeta,
        content_type: from?.meta?.contentType,
        base_shop: lowerCaseShop(previousMenu.value),
      },
      category: 'content',
      action: 'page view',
      label: 'virtual',
    })
  },
})

export default useContentEvents
